import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'styled-checkbox',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const internalValue = computed({
  get: () => props.modelValue,
  set: (newValue: boolean) => {
    emit("update:modelValue", newValue);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["styled-checkbox", { checked: !!_ctx.modelValue }])
  }, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event))
    }, null, 512), [
      [_vModelCheckbox, internalValue.value]
    ])
  ], 2))
}
}

})